import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from './firebase';
import { COLLECTIONS } from './firestore';
import { PLAN_IDS } from '../utils/subscription';

export class SubscriptionService {
  static async getLaunchSubscriberCount() {
    const activeSubscribersQuery = query(
      collection(db, COLLECTIONS.USERS),
      where('subscription.status', '==', 'active')
    );
    const snapshot = await getDocs(activeSubscribersQuery);
    return snapshot.docs.filter((docSnap) => {
      const planId = docSnap.data()?.subscription?.planId;
      return planId === PLAN_IDS.BASIC || planId === PLAN_IDS.PRO;
    }).length;
  }

  static async getUserDocumentCount(userId) {
    if (!userId) return 0;
    const documentsQuery = query(
      collection(db, COLLECTIONS.DOCUMENTS),
      where('userId', '==', userId)
    );
    const snapshot = await getDocs(documentsQuery);
    return snapshot.size;
  }
}
